$checkoutStep2RechSelect = $(".js-checkout_step_2_rech_select");
$checkoutStep2LiefSelect = $(".js-checkout_step_2_rech_select");

if(typeof $checkoutStep2RechSelect != "undefined" && $checkoutStep2RechSelect.length > 0){
    checkoutStep2ToggleFormRech(true);
}

if(typeof $checkoutStep2LiefSelect != "undefined" && $checkoutStep2LiefSelect.length > 0){
    checkoutStep2ToggleFormLief(true);
}

$(document).on("change", ".js-checkout_step_2_rech_select", function(e){
    e.preventDefault();
    checkoutStep2ToggleFormRech(false);
});

$(document).on("change", ".js-checkout_step_2_lief_select", function(e){
    e.preventDefault();
    checkoutStep2ToggleFormLief(false);
});

function checkoutStep2ToggleFormRech(init){
    formMsgBlockHide();
    var selectedOption = $(".js-checkout_step_2_rech_select").find("option:selected").val();

    if(selectedOption == 0){
        $(".js-checkout_step_2_rech").slideDown().css("display", "flex");
        if(init) return;
        checkoutClearRech();
        hideLoader();
    }else{
        showLoader();
        $.ajax({
            url:root + "cmshx_template/ajax/checkout_get_address.php",
            data:{a:selectedOption,
                  csrf_token:csrf_token
            },
            type:"POST",
            dataType:"json",
        }).done(function(response){
            var $input = $(".js-checkout_step_2_rech_select");
            var labelObject = $input.siblings(".js-form_label");
            var labelName = labelObject.data("label");
            $(".js-checkout_step_2_rech").slideUp();

            if(response.valid){
                $("[name=\"rech_id_eckunde_anrede\"]").val(response.id_eckunde_anrede).attr("value", response.id_eckunde_anrede);
                $("[name=\"rech_adr_vorname\"]").val(response.adr_vorname).attr("value", response.adr_vorname);
                $("[name=\"rech_adr_nachname\"]").val(response.adr_nachname).attr("value", response.adr_nachname);
                $("[name=\"rech_adr_firma\"]").val(response.adr_firma).attr("value", response.adr_firma);
                $("[name=\"rech_adr_adresse\"]").val(response.adr_adresse).attr("value", response.adr_adresse);
                $("[name=\"rech_adr_adresse_2\"]").val(response.adr_adresse_2).attr("value", response.adr_adresse_2);
                $("[name=\"rech_adr_plz\"]").val(response.adr_plz).attr("value", response.adr_plz);
                $("[name=\"rech_adr_ort\"]").val(response.adr_ort).attr("value", response.adr_ort);
                $("[name=\"rech_adr_tel\"]").val(response.adr_tel).attr("value", response.adr_tel);
                $("[name=\"rech_adr_fax\"]").val(response.adr_fax).attr("value", response.adr_fax);
                $("[name=\"rech_id_ecprod_land\"]").val(response.id_ecprod_land).attr("value", response.id_ecprod_land);
                $("[name=\"rech_adr_ust_idnr\"]").val(response.adr_ust_idnr).attr("value", response.adr_ust_idnr);
                if(labelName != "") labelObject.removeClass("form_label_text-error").html(labelName);

                var selectedOptionLief = $(".js-checkout_step_2_lief_select").find("option:selected").val();
                if(selectedOptionLief == "rech"){
                    checkoutFillLiefFromRech();
                }
            }else{
                checkoutClearRech();

                if(labelName != "") labelObject.addClass("form_label_text-error").html(labelName + " - " + $input.data("error"));
            }
            hideLoader();
        });

    }
}

function checkoutStep2ToggleFormLief(init){
    var selectedOption = $(".js-checkout_step_2_lief_select").find("option:selected").val();
    formMsgBlockHide();
    if(selectedOption == 0){
        $(".js-checkout_step_2_lief").slideDown().css("display", "flex");
        if(init) return;
        checkoutClearLief();

        hideLoader();
    }else if(selectedOption == "rech"){
        $(".js-checkout_step_2_lief").slideUp();

        checkoutFillLiefFromRech();
        if(init) return;

        hideLoader();
    }else{
        showLoader();

        $.ajax({
            url:root + "cmshx_template/ajax/checkout_get_address.php",
            data:{a:selectedOption,
                  csrf_token:csrf_token
            },
            type:"POST",
            dataType:"json",
        }).done(function(response){
            var $input = $(".js-checkout_step_2_lief_select");
            var labelObject = $input.siblings(".js-form_label");
            var labelName = labelObject.data("label");
            $(".js-checkout_step_2_lief").slideUp();

            if(response.valid){
                $("[name=\"lief_id_eckunde_anrede\"]").val(response.id_eckunde_anrede).attr("value", response.id_eckunde_anrede);
                $("[name=\"lief_adr_vorname\"]").val(response.adr_vorname).attr("value", response.adr_vorname);
                $("[name=\"lief_adr_nachname\"]").val(response.adr_nachname).attr("value", response.adr_nachname);
                $("[name=\"lief_adr_firma\"]").val(response.adr_firma).attr("value", response.adr_firma);
                $("[name=\"lief_adr_adresse\"]").val(response.adr_adresse).attr("value", response.adr_adresse);
                $("[name=\"lief_adr_adresse_2\"]").val(response.adr_adresse_2).attr("value", response.adr_adresse_2);
                $("[name=\"lief_adr_plz\"]").val(response.adr_plz).attr("value", response.adr_plz);
                $("[name=\"lief_adr_ort\"]").val(response.adr_ort).attr("value", response.adr_ort);
                $("[name=\"lief_adr_tel\"]").val(response.adr_tel).attr("value", response.adr_tel);
                $("[name=\"lief_adr_fax\"]").val(response.adr_fax).attr("value", response.adr_fax);
                $("[name=\"lief_id_ecprod_land\"]").val(response.id_ecprod_land).attr("value", response.id_ecprod_land);
                if(labelName != "") labelObject.removeClass("form_label_text-error").html(labelName);
            }else{
                checkoutClearLief();
                if(labelName != "") labelObject.addClass("form_label_text-error").html(labelName + " - " + $input.data("error"));
            }
            hideLoader();
        });
    }
}

function checkoutClearRech(){
    $("[name=\"rech_id_eckunde_anrede\"]").find('option:eq(0)').prop('selected', true);
    $("[name=\"rech_adr_vorname\"]").val("").attr("value", "");
    $("[name=\"rech_adr_nachname\"]").val("").attr("value", "");
    $("[name=\"rech_adr_firma\"]").val("").attr("value", "");
    $("[name=\"rech_adr_adresse\"]").val("").attr("value", "");
    $("[name=\"rech_adr_adresse_2\"]").val("").attr("value", "");
    $("[name=\"rech_adr_plz\"]").val("").attr("value", "");
    $("[name=\"rech_adr_ort\"]").val("").attr("value", "");
    $("[name=\"rech_adr_tel\"]").val("").attr("value", "");
    $("[name=\"rech_adr_fax\"]").val("").attr("value", "");
    $("[name=\"rech_id_ecprod_land\"]").find('option:eq(0)').prop('selected', true);
    $("[name=\"rech_adr_ust_idnr\"]").val("").attr("value", "");
}

function checkoutClearLief(){
    $("[name=\"lief_id_eckunde_anrede\"]").find('option:eq(0)').prop('selected', true);
    $("[name=\"lief_adr_vorname\"]").val("").attr("value", "");
    $("[name=\"lief_adr_nachname\"]").val("").attr("value", "");
    $("[name=\"lief_adr_firma\"]").val("").attr("value", "");
    $("[name=\"lief_adr_adresse\"]").val("").attr("value", "");
    $("[name=\"lief_adr_adresse_2\"]").val("").attr("value", "");
    $("[name=\"lief_adr_plz\"]").val("").attr("value", "");
    $("[name=\"lief_adr_ort\"]").val("").attr("value", "");
    $("[name=\"lief_adr_tel\"]").val("").attr("value", "");
    $("[name=\"lief_adr_fax\"]").val("").attr("value", "");
    $("[name=\"lief_id_ecprod_land\"]").find('option:eq(0)').prop('selected', true);
}

function checkoutFillLiefFromRech(){
    var rech_id_eckunde_anrede = $("[name=\"rech_id_eckunde_anrede\"]").val();
    var rech_adr_vorname = $("[name=\"rech_adr_vorname\"]").val();
    var rech_adr_nachname = $("[name=\"rech_adr_nachname\"]").val();
    var rech_adr_firma = $("[name=\"rech_adr_firma\"]").val();
    var rech_adr_adresse = $("[name=\"rech_adr_adresse\"]").val();
    var rech_adr_adresse_2 = $("[name=\"rech_adr_adresse_2\"]").val();
    var rech_adr_plz = $("[name=\"rech_adr_plz\"]").val();
    var rech_adr_ort = $("[name=\"rech_adr_ort\"]").val();
    var rech_adr_tel = $("[name=\"rech_adr_tel\"]").val();
    var rech_adr_fax = $("[name=\"rech_adr_fax\"]").val();
    var rech_id_ecprod_land = $("[name=\"rech_id_ecprod_land\"]").val();

    $("[name=\"lief_id_eckunde_anrede\"]").val(rech_id_eckunde_anrede).attr("value", rech_id_eckunde_anrede);
    $("[name=\"lief_adr_vorname\"]").val(rech_adr_vorname).attr("value", rech_adr_vorname);
    $("[name=\"lief_adr_nachname\"]").val(rech_adr_nachname).attr("value", rech_adr_nachname);
    $("[name=\"lief_adr_firma\"]").val(rech_adr_firma).attr("value", rech_adr_firma);
    $("[name=\"lief_adr_adresse\"]").val(rech_adr_adresse).attr("value", rech_adr_adresse);
    $("[name=\"lief_adr_adresse_2\"]").val(rech_adr_adresse_2).attr("value", rech_adr_adresse_2);
    $("[name=\"lief_adr_plz\"]").val(rech_adr_plz).attr("value", rech_adr_plz);
    $("[name=\"lief_adr_ort\"]").val(rech_adr_ort).attr("value", rech_adr_ort);
    $("[name=\"lief_adr_tel\"]").val(rech_adr_tel).attr("value", rech_adr_tel);
    $("[name=\"lief_adr_fax\"]").val(rech_adr_fax).attr("value", rech_adr_fax);
    $("[name=\"lief_id_ecprod_land\"]").val(rech_id_ecprod_land).attr("value", rech_id_ecprod_land);
}